import { useDataValue, useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let subscriber = useDataValue({
    context: 'subscriber',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
    path: 'subscriber',
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onClick() {
    change(subscriber)
    setFlowTo(
      normalizePath(props.viewPath, '../../../../../../DeleteModal/Content')
    )
  }
}
